/* ============================================================
   Vitals (Vtl-) Wishlist — özel proxy kalpleri
   header + ürün başlığı + koleksiyon kartları.

   Mimari (Faz 2 — sağlamlaştırılmış):
   • MutationObserver YOK, sepete temas YOK.
   • Durumu Vitals'ın render'ından okur (SVG path imzası).
   • Senkron tetikleyiciler: Vitals'ın 'vitals:RenderWishlistIcons' event'i
     (jQuery ile fırlatılıyor → $ hazır olunca bağlanır) + sınırlı bir poll
     (geç/asenkron render'ı yakalamak için, sonsuz observer yerine) +
     'pagereveal' (Savor view-transition navigasyonu) + 'storage'.

   CSS: assets/wishlist-proxy.css | Yükleyen: snippets/wishlist-proxy.liquid
   Vitals iç bilgisi: memory vitals-wishlist-internals.
   ============================================================ */
(() => {
  'use strict';

  const REAL_HEADER  = '.Vtl-WishlistHeaderWrapper';
  const REAL_COUNTER = REAL_HEADER + ' .Vtl-WishlistHeader__HeartCounter';
  const PRODUCT_WRAP = '.Vtl-WishlistIcon__ProductPageWrapper';
  const BTN          = '.Vtl-WishlistButton__WishlistIconButton';
  const PRODUCT_INFO = '[data-testid="product-information-details"], [id^="ProductInformation-"]';
  const WL_KEY       = '__v__wl__l__';
  const WL_HREF      = '/apps/page/wishlist';

  /* Header kalbi: ince outline (24 viewBox). */
  const HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  /* Ürün kalbi: Vitals'ın TAM path verisi (512 viewBox) — mirror yerine kendi
     SVG'mizi basıyoruz ama birebir aynı görünsün diye Vitals'ın iki şeklini
     kullanıyoruz. favoride=solid, değil=outline (memory: vitals-wishlist-internals). */
  const SOLID_D = 'M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z';
  const OUTLINE_D = 'm244 84 11.1 12 12-11.98C300.6 51.37 347 36.51 392.6 44.1c68.9 11.48 119.4 71.1 119.4 141v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.59 300.4C17.23 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.52-129.52 119.4-141 44.7-7.59 92 7.27 124.6 39.9-.9 0 0 .01 0 0zm11.1 79.9-45-46.8c-21.7-20.82-52.5-30.7-82.8-25.66C81.55 99.07 48 138.7 48 185.1v5.8c0 28.2 11.71 55.2 32.34 74.4L256 429.3l175.7-164c20.6-19.2 32.3-46.2 32.3-74.4v-5.8c0-46.4-33.6-86.03-79.3-93.66-30.3-5.04-61.1 4.84-82.8 25.66l-46.8 46.8z';
  const productSvg = (fav) => `<svg viewBox="0 0 512 512" aria-hidden="true"><path d="${fav ? SOLID_D : OUTLINE_D}"/></svg>`;

  /* Favoride mi? Doğrulanmış imza (memory: vitals-wishlist-internals):
     favoride = solid, tek path ("M462…"); değil = outline, alt-path'li ("m244…").
     path yok/geçiş anı => null (bilinmiyor, dokunma). */
  const isFav = (btn) => {
    const path = btn && btn.querySelector('svg path');
    const d = path && (path.getAttribute('d') || '').trim();
    if (!d) return null;
    return !(/z\s*m/i.test(d) || (d.match(/[mM]/g) || []).length > 1);
  };

  /* En sağlam, locale-bağımsız sayaç kaynağı: localStorage listesi.
     Yoksa gerçek header sayacına düş. */
  const count = () => {
    try {
      const data = JSON.parse(localStorage.getItem(WL_KEY) || 'null');
      if (data && Array.isArray(data.list)) return data.list.length;
    } catch (e) { /* yoksay */ }
    const rc = document.querySelector(REAL_COUNTER);
    return rc ? parseInt(rc.textContent, 10) || 0 : 0;
  };

  /* ---------------- header ---------------- */
  const cartAnchor = (ha) => {
    let ref = ha.querySelector('[data-testid="cart-drawer-trigger"], cart-icon, a[href*="/cart"]');
    while (ref && ref.parentElement !== ha) ref = ref.parentElement;
    return ref || null;
  };

  const syncHeader = () => {
    const ha = document.querySelector('header-actions');
    if (!ha) return;
    let p = ha.querySelector(':scope > .yip-header-wishlist-proxy');
    if (!p) {
      p = document.createElement('a');
      p.className = 'yip-header-wishlist-proxy';
      p.href = WL_HREF;
      p.setAttribute('aria-label', 'Favori listesi');
      p.innerHTML = HEART + '<span class="yip-header-wishlist-proxy__counter"></span>';
      ha.insertBefore(p, cartAnchor(ha));
    }
    const badge = p.querySelector('.yip-header-wishlist-proxy__counter');
    const n = count();
    const txt = n > 0 ? String(n) : '';
    if (badge.textContent !== txt) badge.textContent = txt;
  };

  /* ---------------- ürün ---------------- */
  const titleBlock = (info) => {
    const b = info.querySelector('.text-block.h1');
    if (b && b.querySelector(':scope > h1')) return b;
    const h1 = info.querySelector('h1');
    return h1 ? (h1.closest('.text-block') || h1.parentElement) : null;
  };

  /* Ana ürün kalbi (header/öneri/kart kopyalarını ele) */
  const productButton = () => {
    const w = [...document.querySelectorAll(PRODUCT_WRAP)].filter((el) =>
      !el.closest('header, header-actions, #header-component, .product-tabs, .product-card, .card-product, product-card') &&
      el.querySelector(BTN)
    ).at(-1);
    return w ? w.querySelector(BTN) : null;
  };

  const syncProduct = () => {
    const info = document.querySelector(PRODUCT_INFO);
    if (!info) return;
    const block = titleBlock(info);
    if (!block) return;

    let p = block.querySelector(':scope > .yip-product-wishlist-proxy');
    if (!p) {
      p = document.createElement('div');
      p.className = 'yip-product-wishlist-proxy';
      p.setAttribute('role', 'button');
      p.tabIndex = 0;
      p.hidden = true;
      p.innerHTML = productSvg(false);          // kendi SVG'miz (mirror yok)
      const toggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const real = productButton();
        if (real) { real.click(); burst(); }    // toggle = gerçek Vitals butonu; sonra durumu yakala
      };
      p.addEventListener('click', toggle);
      p.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
      block.appendChild(p);
    }

    const real = productButton();
    if (!real) { p.hidden = true; return; }     // Vitals henüz render etmedi → poll/event tekrar dener
    p.hidden = false;

    const fav = isFav(real);                     // null = render geçişi → dokunma
    if (fav !== null) {
      const path = p.querySelector('path');
      const d = fav ? SOLID_D : OUTLINE_D;
      if (path && path.getAttribute('d') !== d) path.setAttribute('d', d);
      p.classList.toggle('is-fav', fav);
      const label = fav ? 'Favorilerden çıkar' : 'Favorilere ekle';
      if (p.getAttribute('aria-label') !== label) p.setAttribute('aria-label', label);
    }
  };

  /* ---------------- kartlar (yalnız favoride görünür) ---------------- */
  const syncCards = () => {
    document.querySelectorAll('.Vtl-CollectionCardWidget').forEach((card) => {
      const fav = isFav(card.querySelector(BTN)) === true;
      if (card.classList.contains('yip-card-active') !== fav)
        card.classList.toggle('yip-card-active', fav);
    });
  };

  /* ---------------- çalıştır + tetikleyiciler ---------------- */
  const run = () => {
    if (document.body)
      document.body.classList.toggle('yip-wishlist-page', location.pathname.includes(WL_HREF));
    syncHeader();
    syncProduct();
    syncCards();
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  };

  /* Vitals async render eder; observer yerine sınırlı poll ile geç render'ı yakala. */
  const burst = () => [0, 150, 400, 900, 1800].forEach((t) => setTimeout(schedule, t));

  /* 'vitals:RenderWishlistIcons' jQuery ile fırlatılıyor → $ hazır olunca bağla. */
  const bindVitals = (n = 40) => {
    if (typeof window.$ === 'function') {
      try { window.$(document).on('vitals:RenderWishlistIcons', schedule); } catch (e) { /* yoksay */ }
    } else if (n > 0) {
      setTimeout(() => bindVitals(n - 1), 150);
    }
  };

  burst();
  bindVitals();
  window.addEventListener('storage', (e) => { if (e.key === WL_KEY) schedule(); });
  window.addEventListener('pagereveal', burst);            // Savor view-transition navigasyonu
  document.addEventListener('shopify:section:load', burst); // tema editörü
})();
